import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import _pt from "prop-types";
var _excluded = ["id", "className", "children", "isOpen", "onClose", "position", "base", "sm", "md", "lg", "xl"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.concat.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useRef } from 'react';
import classNames from 'classnames';
import "../panel.css";
import { ContainerPush } from './ContainerPush';
import { ContainerOverlayTakeover } from './ContainerOverlayTakeover';
import { useCurrentBreakpoint } from '@lmig/lmds-react-modal/dist/hooks/useCurrentBreakpoint';
import { CSSTransition } from 'react-transition-group';
/**
 * @see [LMDS Panel Documentation and Examples](https://designsystem.lmig.com/components/panel/code)
 *
 * API:
 *
 * @implements [PanelProps](https://designsystem.lmig.com/components/panel/code#panel-props)
 * @extends [HTMLDivElement](https://microsoft.github.io/PowerBI-JavaScript/interfaces/_node_modules_typedoc_node_modules_typescript_lib_lib_dom_d_.htmldivelement.html)
 */
export var Panel = function Panel(props) {
  var id = props.id,
    className = props.className,
    children = props.children,
    _props$isOpen = props.isOpen,
    isOpen = _props$isOpen === void 0 ? false : _props$isOpen,
    onClose = props.onClose,
    _props$position = props.position,
    position = _props$position === void 0 ? 'left' : _props$position,
    _props$base = props.base,
    base = _props$base === void 0 ? 'overlay' : _props$base,
    _props$sm = props.sm,
    sm = _props$sm === void 0 ? 'push' : _props$sm,
    _props$md = props.md,
    md = _props$md === void 0 ? 'push' : _props$md,
    _props$lg = props.lg,
    lg = _props$lg === void 0 ? 'push' : _props$lg,
    _props$xl = props.xl,
    xl = _props$xl === void 0 ? 'push' : _props$xl,
    otherProps = _objectWithoutProperties(props, _excluded);
  var containerRef = useRef(null);
  var breakpointTypeObj = {
    base: base,
    sm: sm,
    md: md,
    lg: lg,
    xl: xl
  };

  // gets the active panel type (overlay, push, or takeover) based on the useCurrentBreakpoint hook;
  var currentBreakpoint = useCurrentBreakpoint();
  var activePanelType = breakpointTypeObj[currentBreakpoint];
  var PanelContainer = activePanelType === 'push' ? ContainerPush : ContainerOverlayTakeover;
  var positionClass = "lmig-Panel--".concat(position);
  var containerClasses = classNames('lmig-Panel', "lmig-Panel--".concat(activePanelType), positionClass, {
    'lmig-Panel--open': isOpen
  }, className);

  /** Adds an additional class to the body to hide overflow while the push type onEnter/onExit */
  var handleAnimationStart = function handleAnimationStart() {
    var _document;
    (_document = document) === null || _document === void 0 ? void 0 : _document.body.classList.add('lmig-Panel--freeze-overflow');
  };

  /** Remove the additional class to the body to hide overflow while the push type onEntered/onExited
   * Added delay option because onEnter > onEntering were firing so quickly, the class wasn't being applied.
   */
  var handleAnimationEnd = function handleAnimationEnd() {
    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return function () {
      setTimeout(function () {
        var _document2;
        (_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.body.classList.remove('lmig-Panel--freeze-overflow');
      }, delay);
    };
  };
  return /*#__PURE__*/React.createElement(CSSTransition, _extends({
    "in": isOpen,
    classNames: {},
    timeout: {
      exit: 300
    },
    unmountOnExit: true,
    nodeRef: containerRef,
    addEndListener: null
  }, activePanelType === 'push' && {
    onEnter: handleAnimationStart,
    onEntered: handleAnimationEnd(300),
    onExit: handleAnimationStart,
    onExited: handleAnimationEnd(0)
  }), function (animationState) {
    return /*#__PURE__*/React.createElement(PanelContainer, _extends({
      id: id,
      innerRef: containerRef,
      className: "".concat(containerClasses, " lmig-Panel--").concat(position, "-").concat(animationState)
    }, activePanelType !== 'push' && {
      activePanelType: activePanelType,
      currentBreakpoint: currentBreakpoint,
      onClose: onClose,
      'aria-live': 'polite'
    }, otherProps), children);
  });
};
Panel.propTypes = {
  /** Add a custom ID to this element. */id: _pt.string,
  /** Add custom classes to this element. */className: _pt.string,
  /** Children to display within the `Panel`. */children: _pt.node,
  /** Whether the `Panel` is open
     * @default false
     */
  isOpen: _pt.bool,
  /** Function to call when the user clicks to close the Panel. Will be fired when the `Esc` key is pressed in an `overlay` and `takeover` style. */onClose: _pt.func
};